import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Card,
  Chip
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import EmptyData from "components/EmptyData";
import DriverPlanModal from "DialogBox/DriverPlanModal";
import apiClient from "Utils/apiClient";

const DriverPlans = () => {
  const [allData, setAllData] = useState([]);
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) navigate("/authentication/sign-in");
  }, [navigate]);

  const fetchDriverPlans = async () => {
    try {
      const response = await apiClient.get("/driver-plan");
      if (response && response.data) {
        setAllData(response.data);
      } else {
        setAllData([]);
      }
    } catch (error) {
      console.error("Error fetching driver plans:", error);
      toast.error("Failed to fetch Driver Plans.");
    }
  };

  useEffect(() => {
    fetchDriverPlans();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this plan?")) return;
    try {
      await apiClient.delete(`/driver-plan/${id}`);
      toast.success("Driver Plan deleted successfully.");
      fetchDriverPlans();
    } catch (error) {
      toast.error("Failed to delete Driver Plan.");
      console.error("Delete Error:", error);
    }
  };

  const openModal = (data = null) => {
    setEditData(data);
    setOpen(true);
  };

  const closeModal = () => {
    setEditData(null);
    setOpen(false);
    fetchDriverPlans();
  };

  return (
    <DashboardLayout>
      <MDBox pt={8} pb={3}>
        <button
          className="btn btn-success ms-3 pt-2 pb-2 mb-5"
          style={{ width: 200 }}
          onClick={() => openModal()}
        >
          Add Driver Plan
        </button>

        <DriverPlanModal
          open={open}
          onClose={closeModal}
          editData={editData}
          onSubmit={closeModal}
        />

        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ textAlign: "center" }}
              >
                <ToastContainer />
                <MDTypography
                  variant="h6"
                  color="white"
                  sx={{ fontWeight: "bold", fontSize: "1.5rem" }}
                >
                  DRIVER PLANS
                </MDTypography>
              </MDBox>

              {allData.length > 0 ? (
                <MDBox p={3}>
                  <TableContainer component={Paper}>
                    <Table aria-label="driver plans table">
                      <TableHead sx={{ display: "table-header-group" }}>
                        <TableRow>
                          {[
                            "SR",
                            "Name",
                            "Plan Type",
                            "Price (₦)",
                            "Duration",
                            "Status",
                            "Action",
                          ].map((heading, idx) => (
                            <TableCell
                              key={idx}
                              style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                              align="center"
                            >
                              {heading}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {allData.map((item, index) => (
                          <TableRow key={item._id}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">{item.name}</TableCell>
                            <TableCell align="center">{item.planType}</TableCell>
                            <TableCell align="center">₦{item.price}</TableCell>
                            <TableCell align="center">{item.durationDays} Days</TableCell>
                            <TableCell align="center">
                              {item.isActive ? (
                                <Chip label="Active" color="success" size="small" />
                              ) : (
                                <Chip label="Inactive" color="default" size="small" />
                              )}
                            </TableCell>
                            <TableCell align="center">
                              <button
                                className="btn btn-warning btn-sm me-2"
                                onClick={() => openModal(item)}
                              >
                                Update
                              </button>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleDelete(item._id)}
                              >
                                Delete
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </MDBox>
              ) : (
                <EmptyData />
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default DriverPlans;
